module.exports = __webpack_public_path__ + "static/subpages-quality-tablet.e25b56b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/tablet/subpages-quality-tablet.jpg
// module id = 600
// module chunks = 87895327789742